export default __webpack_public_path__ + "static/media/background.f9cbaef5.jpg";